(() => {
  function initialize(root) {
    if (root.dataset.hiwReady) return;
    const video = root.querySelector('[data-hiw-player]');
    const overlay = root.querySelector('[data-hiw-play]');
    const options = [...root.querySelectorAll('[data-video]')];
    const config = JSON.parse(root.querySelector('[data-hiw-config]').textContent);
    const error = root.querySelector('[data-hiw-error]');
    let selected = (options.find(b => b.getAttribute('aria-pressed') === 'true') || options[0]).dataset.video;
    let revision = 0;
    root.dataset.hiwReady = 'true';
    video.controls = false;
    overlay.hidden = false;
    options.forEach(button => { button.hidden = false; });
    const handleError = () => { error.hidden = false; video.controls = true; overlay.hidden = true; };
    video.addEventListener('error', handleError);
    video.addEventListener('play', () => {
      document.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
      overlay.hidden = true; video.controls = true; error.hidden = true;
    });
    // Home only: the poster waits until the block nears the viewport. The How It Works page keeps its poster in the markup.
    if (!video.getAttribute('poster')) {
      const waitForView = new IntersectionObserver((entries, observer) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        video.poster = config[selected].poster;
      }, { rootMargin: '300px 0px' });
      waitForView.observe(video);
    }
    overlay.addEventListener('click', async () => {
      const attempt = revision;
      video.controls = true; video.muted = false; error.hidden = true;
      try { await video.play(); if (attempt === revision) overlay.hidden = true; }
      catch (err) { if (attempt === revision && err.name !== 'AbortError') handleError(); }
    });
    options.forEach(button => button.addEventListener('click', () => {
      if (selected === button.dataset.video) return;
      revision += 1; video.pause(); selected = button.dataset.video;
      const item = config[selected];
      video.src = item.src; video.poster = item.poster; video.preload = 'none';
      video.controls = false; video.setAttribute('aria-label', item.label); video.load();
      overlay.hidden = false; error.hidden = true;
      overlay.setAttribute('aria-label', 'Play ' + item.label + ' with sound');
      root.querySelector('.hnx-hiw__badge').textContent = item.badge;
      root.querySelector('[data-hiw-credit]').textContent = item.credit;
      root.querySelector('[data-hiw-description]').textContent = item.description;
      root.querySelectorAll('[data-hiw-step]').forEach((step,index) => {
        step.querySelector('h2').textContent = item.steps[index][0];
        step.querySelector('p').textContent = item.steps[index][1];
      });
      options.forEach(option => option.setAttribute('aria-pressed', String(option === button)));
    }));
  }
  function initializeAll(scope) { scope.querySelectorAll('[data-hiw-section]').forEach(initialize); }
  initializeAll(document);
  if (!window.heartnoksHowVideoSectionListener) {
    window.heartnoksHowVideoSectionListener = true;
    document.addEventListener('shopify:section:load', event => initializeAll(event.target));
  }
})();
